const features = {
  agents: 'agents',
  automation: 'automation',
  chat: 'chat',
  categories: 'categories',
  quickActions: 'quickActions',
  escalations: 'escalations',
  form: 'form',
  waitFallback: 'waitFallback',
  transfer: 'transfer',
  communitiesView: 'communities view',
  chatFeedbackRequest: 'chat feedback',
  community: 'community',
  recruitment: 'recruitment',
  invitationPage: 'invitationPage',
  embed: 'embedWidget',
  contentEmbed: 'contentEmbed',
  feedback: 'feedback',
  news: 'news',
  articles: 'articles',
} as const;

const PARTNER_FEATURES = Object.keys(features).map((feat) => ({
  name: feat,
  value: feat,
}));

const FEATURES = [
  ...PARTNER_FEATURES,
  {
    name: 'review',
    value: 'review',
  },
  {
    name: 'recruiting',
    value: 'recruiting',
  },
  {
    name: 'expert view',
    value: 'expertView',
  },
  {
    name: 'guuru activity notifications',
    value: 'expertsInactiveMail',
  },
];

export { PARTNER_FEATURES, FEATURES };
